(function () {
	angular.module('ResearchKitApplicationModule').factory('finishSteps', [function () {

		var finishSteps = [
			{
				identifier: 'FinishStep.Cancel',
				description: "Finish Survey > Cancel",
				nextStep: function (surveyManager) { surveyManager.promptForSurveyClose() }
			},
			{
				identifier: 'FinishStep.CancelAndSave',
				description: "Finish Survey > Cancel and Save",
				nextStep: function (surveyManager) { surveyManager.saveProgressAndClose(); }
			},
			{
				identifier: 'FinishStep.CancelAndDiscard',
				description: "Finish Survey > Cancel and Discard",
				nextStep: function (surveyManager) { surveyManager.deleteProgressAndClose(); }
			},
			{
				identifier: 'FinishStep.Complete',
				description: "Finish Survey > Complete and Submit Results",
				nextStep: function (surveyManager) { surveyManager.endAndComplete(); }
			}
		]

		var getFinishSteps = function () {
			return finishSteps;
		}

		var getFinishStep = function (identifier) {
			return _.findWhere(finishSteps, { 'identifier': identifier });
		}

		return {
			getFinishSteps: getFinishSteps,
			getFinishStep: getFinishStep
		}
	}])
})();